import React from "react";
import CourseTopicMaterials from "../../../hooks/CourseTopicMaterials";
import { frenchCourseTopicMaterials } from "../../../shared/components/FormCourseMaterials/FormCourseMaterials";
import { frenchTextBooks } from "../../../shared/components/FormCourseMaterials/FormImages";
import TextBookImages from "../../../shared/components/TextBookImages/TextBookImages";

import pic9 from '../../../assets/Images/pic2.jpeg';
import pic10 from '../../../assets/Images/pic5.png';

const FrenchContent = () => {
  return (
    <>
      <CourseTopicMaterials items={frenchCourseTopicMaterials} leftImage={pic9} rightImage={pic10} />
      <TextBookImages images={frenchTextBooks} />
    </>
  );
}

export default FrenchContent;
